import { Navigate } from 'react-router-dom';
import Loading from '../../components/Loading';
import type { AssignmentKind } from '../../lib/types';
import { useClassroom } from '../../state/Classroom';

/** /video, /story, /grammar: the open one due soonest, or a note that there isn't one. */
export default function CurrentAssignment({ kind }: { kind: AssignmentKind }) {
  const { hydrated, current } = useClassroom();
  if (!hydrated) return <Loading />;
  const a = current(kind);
  if (a) return <Navigate to={`/a/${a.id}`} replace />;
  return (
    <div className="notice">
      No {kind} is open right now. Check back when your teacher posts new work.
    </div>
  );
}
